import classNames from 'classnames';
import styles from './ArticleText.module.scss';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
export interface ArticleTextProps {
	content: string;
	className?: string;
}

export const UI_ArticleText = ({ className, content }: ArticleTextProps) => (
	<div className={classNames(styles.ArticleText, className)}>
		<UI_RichText content={content} />
	</div>
);
